import { API } from '@Providers';

interface AdoptionFeePayload {
  animals: {
    adoption_fee: string;
    animal_id: string;
    outcome_field: boolean; // NOTE: always true
  };
}

export default async function (payload: AdoptionFeePayload) {
  const endpoint = '/api/shelter/animal/update-cart-animal-adoption-fee';

  return API({ endpoint, method: 'post', payload });
}
